import {useCallback, useEffect} from "react";

import useInterval from "../../../core/util/hook/useInterval";
import {CurrentAssetPrices} from "../../util/assetModels";
import assetApi from "../../api/assetApi";
import usePureState from "../../../core/util/hook/usePureState";

const FETCH_ASSET_PRICES_POLLING_INTERVAL = 30000;

function useFetchAssetPrices() {
  const [prices, setPrices] = usePureState<CurrentAssetPrices>({});

  const fetchPrices = useCallback(() => {
    assetApi.getCurrentAssetPrices().then((response) => {
      setPrices(response);
    });
  }, [setPrices]);

  useEffect(() => {
    fetchPrices();
  }, [fetchPrices]);

  useInterval(() => {
    fetchPrices();
  }, FETCH_ASSET_PRICES_POLLING_INTERVAL);

  return prices;
}

export default useFetchAssetPrices;
